"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ecommerce_1 = require("../../../../api/ecommerce");
const cachedFetchApi_1 = __importDefault(require("../../../../common/js/apis/helper/cachedFetchApi"));
const PortalAreaMiddleware_1 = __importDefault(require("../../middleware/PortalAreaMiddleware"));
const ShopAuthorizationMiddleware_1 = __importDefault(require("../../middleware/ShopAuthorizationMiddleware"));
const ShopLanguageMiddleware_1 = __importDefault(require("../../middleware/ShopLanguageMiddleware"));
const configuration = new ecommerce_1.Configuration({
    basePath: `https://${__APP__.ECOMMERCE_HOST}`,
    credentials: 'omit',
    middleware: [PortalAreaMiddleware_1.default, ShopAuthorizationMiddleware_1.default, ShopLanguageMiddleware_1.default],
    fetchApi: cachedFetchApi_1.default,
});
exports.default = configuration;
